import axios from "axios";
import { dateToJalali, faDigitsStr, pad2, JALALI_MONTHS } from "./jalali";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// ---------- session (admin یا کاربر پنل) ----------
const TOKEN_KEYS = ["admin_token", "portal_token", "portal_role"];

export function getToken() {
  return localStorage.getItem("admin_token") || localStorage.getItem("portal_token") || "";
}

export function getRole() {
  return localStorage.getItem("portal_role") || "";
}

export function saveSession({ token, role }) {
  if (role === "admin") {
    localStorage.setItem("admin_token", token);
    localStorage.removeItem("portal_token");
  } else {
    localStorage.setItem("portal_token", token);
    localStorage.removeItem("admin_token");
  }
  localStorage.setItem("portal_role", role);
}

export function clearSession() {
  TOKEN_KEYS.forEach((k) => localStorage.removeItem(k));
}

// attach the session token to every request
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// expired/invalid session -> back to login (OTP verify errors are excluded)
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && !url.includes("/auth/")) {
      clearSession();
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

// ---------- formatting ----------
export function faDigits(v) {
  if (v === null || v === undefined) return "";
  const s = String(v);
  return s.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[+d]);
}

export function timeAgo(ts) {
  if (!ts) return "-";
  const diff = Date.now() / 1000 - ts;
  if (diff < 60) return `${Math.floor(diff)} ثانیه پیش`;
  if (diff < 3600) return `${Math.floor(diff / 60)} دقیقه پیش`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} ساعت پیش`;
  return `${Math.floor(diff / 86400)} روز پیش`;
}

export function fmtDate(ts) {
  if (!ts) return "-";
  const d = new Date(ts * (ts > 10_000_000_000 ? 1 : 1000));
  return d.toLocaleString("fa-IR");
}

// unix seconds -> «۱۴۰۵/۰۸/۰۱» (شمسی)
export function fmtJalaliDate(ts) {
  if (!ts) return "-";
  const { jy, jm, jd } = dateToJalali(new Date(ts * 1000));
  return faDigitsStr(`${jy}/${pad2(jm)}/${pad2(jd)}`);
}

export function fmtJalaliDateTime(ts) {
  if (!ts) return "-";
  const { jy, jm, jd, hh, mm } = dateToJalali(new Date(ts * 1000));
  return faDigitsStr(`${jy}/${pad2(jm)}/${pad2(jd)} ${pad2(hh)}:${pad2(mm)}`);
}

export { JALALI_MONTHS };

// Numbers with thousands separators, e.g. 21,458,874 (Persian digits).
export function faNum(v) {
  if (v === null || v === undefined || v === "") return "";
  const n = Number(v);
  if (Number.isNaN(n)) return faDigits(v);
  return faDigits(n.toLocaleString("en-US", { maximumFractionDigits: 2 }));
}

// Gregorian YYYY-MM-DD (from <input type="date">) -> unix seconds at Tehran midnight (UTC+3:30)
export function tehranMidnightTs(ymd) {
  if (!ymd) return 0;
  return Math.floor(new Date(`${ymd}T00:00:00+03:30`).getTime() / 1000);
}

export function errMsg(err, fallback = "خطا در انجام عملیات") {
  const d = err?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
}
